import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import { store } from "./app/store";
import App from "./App";

const container = document.getElementById("root");
const root = container && createRoot(container);

root?.render(
	<React.StrictMode>
		<Provider store={store}>
			<HashRouter basename="/">
				<HelmetProvider>
					<App />
				</HelmetProvider>
			</HashRouter>
		</Provider>
	</React.StrictMode>
);
